/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Styles
import borders from "assets/theme/base/borders";
import typography from "assets/theme/base/typography";

// Soft UI Dashboard PRO React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { size, fontWeightRegular } = typography;
const { borderRadius } = borders;

export default {
  styleOverrides: {
    root: ({ theme }) => ({
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      flex: "1 1 auto",
      textAlign: "center",
      maxWidth: "unset !important",
      minWidth: "unset !important",
      minHeight: "unset !important",
      fontSize: size.regular,
      fontWeight: fontWeightRegular,
      textTransform: "none",
      lineHeight: "inherit",
      padding: pxToRem(4),
      borderRadius: borderRadius.md,
      opacity: "1 !important",
      transition: "color 300ms ease",

      // Same color for all states — only weight changes
      color:
        theme.palette.mode === "dark"
          ? "rgba(255,255,255,0.65) !important"
          : `${theme.palette.dark?.main || "#344767"} !important`,

      // SVG icons: inherit the tab's current text color
      "& svg g": {
        fill: "currentColor",
      },
      "& svg path": {
        fill: "currentColor",
      },

      // Selected state — bold only, no color change
      "&.Mui-selected": {
        color:
          theme.palette.mode === "dark"
            ? "rgba(255,255,255,0.65) !important"
            : `${theme.palette.dark?.main || "#344767"} !important`,
        fontWeight: "700 !important",
      },

      "& .material-icons, .material-icons-round": {
        marginBottom: "0 !important",
        marginRight: pxToRem(4),
      },

      "& svg": {
        marginBottom: "0 !important",
        marginRight: pxToRem(6),
      },
    }),

    labelIcon: {
      paddingTop: pxToRem(4),
    },
  },
};
